customElements.whenDefined('header-menu').then(() => {
  document.querySelectorAll('header-menu').forEach(menu => {
    const allDetails = menu.querySelectorAll('details');
    allDetails.forEach(details => {
      const submenu = details.querySelector('.header__submenu');
      if (!submenu) return;

      details.addEventListener('toggle', () => {
        if (!details.open) return;
        allDetails.forEach(other => {
          if (other !== details && other.open) {
            const otherSub = other.querySelector('.header__submenu');
            if (otherSub) {
              otherSub.style.transition = 'opacity 0.15s ease, transform 0.15s ease';
              otherSub.style.opacity = '0';
              otherSub.style.transform = 'translateY(-6px)';
              setTimeout(() => {
                other.removeAttribute('open');
                otherSub.style.opacity = '';
                otherSub.style.transform = '';
                otherSub.style.transition = '';
              }, 150);
            } else {
              other.removeAttribute('open');
            }
          }
        });
      });
    });

    const origClose = menu.close;
    if (typeof origClose !== 'function') return;
    menu.close = function() {
      const openDetails = menu.querySelectorAll('details[open]');
      if (!openDetails.length) return origClose.call(menu);
      let pending = openDetails.length;
      openDetails.forEach(d => {
        const sub = d.querySelector('.header__submenu');
        if (sub) {
          sub.style.transition = 'opacity 0.15s ease, transform 0.15s ease';
          sub.style.opacity = '0';
          sub.style.transform = 'translateY(-6px)';
        }
      });
      setTimeout(() => {
        origClose.call(menu);
        openDetails.forEach(d => {
          const sub = d.querySelector('.header__submenu');
          if (sub) {
            sub.style.opacity = '';
            sub.style.transform = '';
            sub.style.transition = '';
          }
        });
      }, 150);
    };
  });
});
